export enum GCClassificationUniqueTypeEnum {
  New = 0,
  WithoutPurchase = 1,
  NotUnique = -1,
}
